import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="loading-container">
      <div className="spin"></div>
    </div>
  );
};

export default LoadingSpinner;
